import { frCA } from 'date-fns/locale';

import { frFR } from '@mui/x-date-pickers/locales';

import { supportedLngs, useTransl } from '.';

export const useMuiPickerLocale = () => {
  const { i18n } = useTransl();

  const isFr = i18n.language === supportedLngs.fr;
  const localeText = isFr
    ? frFR.components.MuiLocalizationProvider.defaultProps.localeText
    : null;
  const adapterLocale = isFr ? frCA : null;

  return { localeText, adapterLocale };
};
